import { render } from "./Experiences.vue?vue&type=template&id=2d6004fd&scoped=true"
import script from "./Experiences.vue?vue&type=script&lang=js"
export * from "./Experiences.vue?vue&type=script&lang=js"

import "./Experiences.vue?vue&type=style&index=0&id=2d6004fd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d6004fd"

export default script